module.exports = __webpack_public_path__ + "img/10578814.d09e8220.png";